{
    "Profile_SupernovaCommercial_Insureds.additionalInsuredsInfo": "Additional Insureds Info",
    "Profile_SupernovaCommercial_Insureds.details": "Details",
    "Profile_SupernovaCommercial_Insureds.requireAdditionalInsured": "Do any clients or business associates require you to add them as an Additional Insured to your policy?",
    "Profile_SupernovaCommercial_Insureds.additionalInsureds": "Additional Insureds"
}
